import React, { useState } from "react";
import { useApi } from "../../hooks/useApi";
import { useAuth } from "../../context/AuthContext";
import {
  Card,
  Spinner,
  ErrorBox,
  SimpleTable,
} from "../../components/ui/basics";
import CrudModal from "../../components/normative/CrudModal";
import LinkAreeModal from "./LinkAreeModal";
import { TIPO } from "../../constants/normativeTipo";

export default function MansioniBlock({ regioni }) {
  const { apiRequest } = useAuth();
  const { data, loading, error, reload } = useApi("/normative/mansioni");
  const { data: aree } = useApi("/normative/aree");
  const [modal, setModal] = useState(null);
  const [linkModal, setLinkModal] = useState(null);

  const fields = [
    {
      key: "codice",
      label: "Codice",
      required: true,
      disabled: modal?.mode === "edit",
    },
    { key: "name", label: "Nome", required: true },
    { key: "ordine", label: "Ordine", type: "number" },
    {
      key: "parentcodice",
      label: "Tipologia/area di appartenenza (codice)",
      placeholder: "es. TIP_INF — vedi tab Tipologie mansione",
    },
    {
      key: "etrasversale",
      label: "Trasversale (calcolo a rapporto addetti/ospiti)",
      type: "checkbox",
    },
    {
      key: "escludiSyncMansioni",
      label:
        "Escludi dalla sync automatica da CSV (es. libero professionista/esterno, mai nel CSV paghe)",
      type: "checkbox",
    },
  ];

  const submit = async (values) => {
    const payload = {
      ...values,
      tipo: TIPO.MANSIONE,
      ordine: values.ordine ? Number(values.ordine) : null,
    };
    if (modal.mode === "create") {
      await apiRequest("/normative/anagrafiche", {
        method: "POST",
        body: JSON.stringify(payload),
      });
    } else {
      await apiRequest(`/normative/anagrafiche/${modal.record.id}`, {
        method: "PUT",
        body: JSON.stringify(payload),
      });
    }
    reload();
  };

  const elimina = async (r) => {
    if (!window.confirm(`Eliminare la mansione "${r.name}"?`)) return;
    await apiRequest(`/normative/anagrafiche/${r.id}`, { method: "DELETE" });
    reload();
  };

  return (
    <Card
      title="Mansioni standard"
      actions={
        <button
          onClick={() => setModal({ mode: "create" })}
          className="text-sm bg-primary-600 text-white px-3 py-1.5 rounded hover:bg-primary-700"
        >
          + Nuova mansione
        </button>
      }
    >
      {loading && <Spinner />}
      {error && <ErrorBox message={error} onRetry={reload} />}
      {data && (
        <SimpleTable
          rowKey={(r) => r.id}
          columns={[
            { key: "codice", label: "Codice" },
            { key: "name", label: "Nome" },
            { key: "parentcodice", label: "Parent" },
            { key: "ordine", label: "Ordine", align: "right" },
            {
              key: "azioni",
              label: "",
              render: (r) => (
                <div className="flex gap-2 justify-end">
                  <button
                    onClick={() => setLinkModal(r)}
                    className="text-xs text-primary-600 hover:underline"
                  >
                    Link aree
                  </button>
                  <button
                    onClick={() => setModal({ mode: "edit", record: r })}
                    className="text-xs text-primary-600 hover:underline"
                  >
                    Modifica
                  </button>
                  <button
                    onClick={() => elimina(r)}
                    className="text-xs text-red-600 hover:underline"
                  >
                    Elimina
                  </button>
                </div>
              ),
            },
          ]}
          rows={data}
        />
      )}
      {modal && (
        <CrudModal
          title={
            modal.mode === "create"
              ? "Nuova mansione"
              : `Modifica ${modal.record.name}`
          }
          fields={fields}
          initialValues={modal.record || {}}
          onSubmit={submit}
          onClose={() => setModal(null)}
        />
      )}
      {linkModal && aree && (
        <LinkAreeModal
          mansione={linkModal}
          regioni={regioni}
          aree={aree}
          onClose={() => setLinkModal(null)}
          onSaved={reload}
        />
      )}
    </Card>
  );
}
